import type { InvestmentFormInput } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";

export const INVESTMENT_FORM_DEFAULT_VALUES: InvestmentFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	productCategoryId: null,
	maturityLengthMonths: null,
	signedAt: null,
	startAt: null,
	endAt: null,
};
